module.exports = __webpack_public_path__ + "resources/f73966e84da5cefb55bc88f287680a42.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/background-cost.png
// module id = 188
// module chunks = 0